<template>
    <Popup ref="popup" :animation="'scale'" >
        <div class="payment-cont" >
            <img class="payment-bg" :src="_global.assetsRoot + '/pay_popup.png'" />
            <div class="content" >
                <div class="close t-r v-m" >
                    <img class="v-m btn" :src="_global.assetsRoot + '/pay_popup_close.png'" @click.stop="cancel" />
                </div>
                <div class="flex-5" >
                    <img class="v-m f-l" :src="_global.assetsRoot + '/pay_icon.png'" />
                    <span class="segoe fs-1-4" >{{ $t("message.paymentTitle") }}</span>
                </div>
                <div class="ok t-c" >
                    <div class="btn pix-btn v-m" @click.stop="gotoPayment('fix')" >
                        <img class="v-m" :src="_global.assetsRoot + '/pix_icon.png'" />
                        <span class="segoe v-m fs-1-8" >{{ $t("message.pix") }}</span>
                    </div>
                    <div class="btn other-ways v-m" @click.stop="gotoPayment(null)" >
                        <span class="segoe v-m fs-1" v-html="$t('message.otherWays')" ></span>
                    </div>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue'

var hostname = window.location.hostname;
const paymentHost = hostname == 'store.drbingo.com' ? 'https://www.drbingo.com' : 'https://staging.doutorbingo.com';

export default {
    props: {
        paymentId: String
    },
    data() {
        return {
            handle: null
        }
    },
    methods: {
        show() { this.$refs.popup.show() },
        cancel() {
            this.$emit("onhide")
            this.hide();
        },
        hide() { this.$refs.popup.hide() },
        gotoPayment(type) {
            this.$emit("payment")
            this.handle = window.open(`${paymentHost}/pay.htm?platform=secret&paymentId=${this.paymentId}${type ? `&type=fix`: ''}`);
        }
    },
    components: { Popup }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.payment-cont {
    position: relative;
    width: 593px;
    margin: 0 auto;

    .payment-bg {
        width: 100%;
    }

    .content {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;

        .close {
            flex: 2;

            img {
                height: 100%;
            }
        }

        .flex-5 {
            flex: 9;
            box-sizing: border-box;
            padding: 0 2rem;
            overflow: hidden;

            img {
                margin-top: 1.5rem;
                width: 20%;
            }

            span {
                display: inline-block;
                width: 78%;
                margin-top: 1.5rem;
                line-height: 2rem;
                color: #FFF;
            }
        }

        .ok {
            flex: 7;

            .btn {
                display: inline-block;
                height: 4.2rem;
                line-height: 4rem;

                span {
                    color: #FFF;
                }
            }

            .pix-btn {
                width: 11rem;
                background: url($assetRoot + "/pix_btn.png") center no-repeat;
                background-size: 100% 100%;

                img {
                    height: 60%;
                    margin-right: .5rem;
                }
            }

            .other-ways {
                width: 13.5rem;
                background: url($assetRoot + "/ok_btn.png") center no-repeat;
                background-size: 100% 100%;
                margin-left: 3rem;
                box-sizing: border-box;
                padding: .5rem 0;
                line-height: 1.5rem;
            }
        }
    }
}

.mobile {
    .payment-cont {
        width: 90%;

        .content {

            .close {

                img {
                    height: 66%;
                }
            }

            .flex-5 {
                padding: 0 3rem;

                img, span {
                    margin-top: 0;
                }

                span {
                    font-size: 1.8rem;
                    line-height: 2.4rem;
                }
            }

            .ok {

                .btn {
                    display: inline-block;
                    height: 4.8rem;
                    line-height: 4.5rem;
                }

                .pix-btn {
                    width: 12.5rem;
                }

                .other-ways {
                    width: 16rem;
                    margin-left: 5rem;
                    box-sizing: border-box;
                    padding: .5rem 0;
                    line-height: 1.8rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Payment.vue